// Indian Numbering System (Lakh / Crore comma grouping) + currency / date helpers
export function formatINR(value) {
  if (value == null || isNaN(value)) return "—";
  const n = Number(value);
  // Indian comma grouping
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(Math.round(n));
  const s = abs.toString();
  let last3 = s.slice(-3);
  const rest = s.slice(0, -3);
  const grouped = rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + last3 : last3;
  return `${sign}₹ ${grouped}`;
}

export function formatINRCompact(value) {
  if (value == null || isNaN(value)) return "—";
  const n = Number(value);
  if (Math.abs(n) >= 1_00_00_000) return `₹ ${(n / 1_00_00_000).toFixed(2)} Cr`;
  if (Math.abs(n) >= 1_00_000) return `₹ ${(n / 1_00_000).toFixed(2)} L`;
  return formatINR(n);
}

export function formatNumber(value) {
  if (value == null || isNaN(value)) return "—";
  return Number(value).toLocaleString("en-IN");
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? iso + "T00:00:00" : iso);
  if (isNaN(d.getTime())) return iso;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return `${formatDate(iso)} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(iso.length === 10 ? iso + "T00:00:00" : iso);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / 86_400_000);
}

export function dueLabel(iso) {
  const d = daysUntil(iso);
  if (d === null) return null;
  if (d === 0) return { text: "Due today", tone: "critical" };
  if (d < 0) return { text: `Overdue by ${Math.abs(d)}d`, tone: "critical" };
  if (d <= 1) return { text: `${d}d remaining`, tone: "critical" };
  if (d <= 3) return { text: `${d}d remaining`, tone: "warning" };
  if (d <= 7) return { text: `${d}d remaining`, tone: "info" };
  return { text: `${d}d remaining`, tone: "muted" };
}

export const STATUS_COLOR = {
  "Pending Review": "bg-amber-100 text-amber-800 border-amber-200",
  "Active": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Under Matching": "bg-blue-100 text-blue-800 border-blue-200",
  "Bid Submitted": "bg-purple-100 text-purple-800 border-purple-200",
  "Won": "bg-green-100 text-green-800 border-green-200",
  "Lost": "bg-red-100 text-red-800 border-red-200",
  "Closed": "bg-slate-100 text-slate-700 border-slate-200",
  "Expired": "bg-zinc-200 text-zinc-700 border-zinc-300",
};
